__turbopack_context__.v({
  "inner": "ProductSections-module__6_UOpq__inner",
  "link": "ProductSections-module__6_UOpq__link",
  "linkWrapper": "ProductSections-module__6_UOpq__linkWrapper",
  "panel": "ProductSections-module__6_UOpq__panel",
  "root": "ProductSections-module__6_UOpq__root",
  "tabs": "ProductSections-module__6_UOpq__tabs",
  "wrapperInner": "ProductSections-module__6_UOpq__wrapperInner",
});
